<template>
  <b-container>
    <b-card class="panel">
    <Loading :active.sync="Loading"></Loading>
    <div class="controles">
      <h2>Reporte por maquina</h2>
    </div>
    <div>
      <b-form-select class="select-maquina" v-model="maquina" :options="maquinasSelectList"></b-form-select>  
      <b-form-select class="select-tiempo" v-model="tiempo" :options="options"></b-form-select>
      <div v-if="tiempo === 1">
            <label for="datepicker-sm">Seleccione el día</label>
            <Vbdatapicker v-model="dia"  />
      </div>
      <div v-if="tiempo === 2">
            <label for="datepicker-sm">Seleccione la semana</label>
            <VbdatapickerWeek v-model="semana"  />
      </div>
      <div v-if="tiempo === 3">
            <label for="datepicker-sm">Seleccione el mes</label>
            <VbdatapickerMonth v-model="mes"  />
      </div>
      <div v-if="tiempo === 4"> 
            <label>Seleccione el año</label>
            <VbdatapickerYear v-model="anno"  />
      </div>
      <b-button class="generar"  @click="generar()">Generar</b-button>
    </div>   
    </b-card>
    <b-card class="panel" v-if="arrData.length > 0">
      <div class="resultado">
        <div>
        <b-table
            :items="reporte" 
            :fields="fields"
        >
            <template v-slot:cell(Contador)="row">
                <div v-if="row.item.Contador != null">
                {{ millar(row.item.Contador)}}
                </div>
            </template>
        </b-table>
        </div>
        <div>
        <BarChart label="Operadores" :chartData="arrData" :options="chartOptions" /> 
        </div>
      </div>  
    </b-card> 
    <b-card class="panel"  v-else>
        <h2>Sin datos.</h2>
    </b-card>  
  </b-container>
</template>

<script>
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import {mapActions, mapState, mapGetters} from 'vuex'
  import _ from 'lodash'
  import BarChart from '@/components/charts/Bar'
  import Vbdatapicker from '@/components/partials/vbdatapicker'
  import VbdatapickerWeek from '@/components/partials/vbdatapickerWeek'
  import VbdatapickerMonth from '@/components/partials/vbdatapickerMonth'
  import VbdatapickerYear from '@/components/partials/vbdatapickerYear'
  import moment from 'moment'
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'Operador',
    mixins : [customMixin],
    components:{
      Loading,BarChart,Vbdatapicker, VbdatapickerWeek, VbdatapickerMonth, VbdatapickerYear
    },
    mounted(){
      this.init()
    },  
    computed:{
      ...mapState(['Loading']), 
      ...mapState('maquina',['reporte']),   
    },
    data:function () {
      return{
        tiempo: null,
        maquina: null,
        dia:null,
        semana:null,
        mes:null,
        anno:null,
        maquinasSelectList:[
          {value:1, text:'Guillotina'},
          {value:2, text:'CD74'},
          {value:3, text:'Bobst106'},
          {value:4, text:'Troq Heidelberg'},
          {value:5, text:'Troq N1'},
          {value:6, text:'Pegadora'},
          {value:7, text:'Cierre OF'}],
        options:[
                    {value: null, text: 'Seleccione la ventana de tiempo'},
                    {value: 1, text: 'Por día'},
                    {value: 2, text: 'Por semana'},
                    {value: 3, text: 'Por mes'},
                    {value: 4, text: 'Por año'},
                    ],
        arrData:[],
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }],
            xAxes: [ {
              gridLines: {
                display: true
              },
            }]
          }
        },
        fields:[
          { key: 'Operador', label: 'Operador'}, 
          { key: 'Contador', label: 'Totales'},
                 
        ]
      }
    },
    methods:{
      ...mapActions({
        _fetchCD74Dia: 'maquina/cd74Dia',
        _fetchCD74Semana: 'maquina/cd74Semana',
        _fetchCD74Mes: 'maquina/cd74Mes',
        _fetchCD74Anno: 'maquina/cd74Anno',
        _fetchGuillotinaDia: 'maquina/guillotinaDia',
        _fetchGuillotinaSemana: 'maquina/guillotinaSemana',
        _fetchGuillotinaMes: 'maquina/guillotinaMes',
        _fetchGuillotinaAnno: 'maquina/guillotinaAnno',
        _fetchBobst106Dia: 'maquina/bobst106Dia',
        _fetchBobst106Semana: 'maquina/bobst106Semana',
        _fetchBobst106Mes: 'maquina/bobst106Mes',
        _fetchBobst106Anno: 'maquina/bobst106Anno',
        _fetchBitTroqueladora3Dia: 'maquina/bittroqueladora3Dia',
        _fetchBitTroqueladora3Semana: 'maquina/bittroqueladora3Semana',
        _fetchBitTroqueladora3Mes: 'maquina/bittroqueladora3Mes',
        _fetchBitTroqueladora3Anno: 'maquina/bittroqueladora3Anno',
        _fetchBitTroqueladoraN1Dia: 'maquina/bittroqueladoran1Dia',
        _fetchBitTroqueladoraN1Semana: 'maquina/bittroqueladoran1Semana',
        _fetchBitTroqueladoraN1Mes: 'maquina/bittroqueladoran1Mes',
        _fetchBitTroqueladoraN1Anno: 'maquina/bittroqueladoran1Anno',
        _fetchBitPegadoraDia: 'maquina/bitpegadoraDia',
        _fetchBitPegadoraSemana: 'maquina/bitpegadoraSemana',
        _fetchBitPegadoraMes: 'maquina/bitpegadoraMes',
        _fetchBitPegadoraAnno: 'maquina/bitpegadoraAnno',
        _fetchCierreOrdenFabricacionDia: 'maquina/cierreordenfabricacionDia',
        _fetchCierreOrdenFabricacionSemana: 'maquina/cierreordenfabricacionSemana',
        _fetchCierreOrdenFabricacionMes: 'maquina/cierreordenfabricacionMes',
        _fetchCierreOrdenFabricacionAnno: 'maquina/cierreordenfabricacionAnno',
       }),
      init(){
        //
      },
      generar(){
        if(this.tiempo === 1){
          if(this.maquina === 1) this.guillotinaDia()
          if(this.maquina === 2) this.cd74Dia()
          if(this.maquina === 3) this.bobst106Dia()
          if(this.maquina === 4) this.bittroqueladora3Dia()
          if(this.maquina === 5) this.bittroqueladoran1Dia()
          if(this.maquina === 6) this.bitpegadoraDia()
          if(this.maquina === 7) this.cierreordenfabricacionDia()
        }
        if(this.tiempo === 2){
          if(this.maquina === 1) this.guillotinaSemana()
          if(this.maquina === 2) this.cd74Semana()
          if(this.maquina === 3) this.bobst106Semana()
          if(this.maquina === 4) this.bittroqueladora3Semana()
          if(this.maquina === 5) this.bittroqueladoran1Semana()
          if(this.maquina === 6) this.bitpegadoraSemana()
          if(this.maquina === 7) this.cierreordenfabricacionSemana()
        }
        if(this.tiempo === 3){
          if(this.maquina === 1) this.guillotinaMes()
          if(this.maquina === 2) this.cd74Mes()
          if(this.maquina === 3) this.bobst106Mes()
          if(this.maquina === 4) this.bittroqueladora3Mes()
          if(this.maquina === 5) this.bittroqueladoran1Mes()
          if(this.maquina === 6) this.bitpegadoraMes()
          if(this.maquina === 7) this.cierreordenfabricacionMes()
        }
        if(this.tiempo === 4){
          if(this.maquina === 1) this.guillotinaAnno()
          if(this.maquina === 2) this.cd74Anno()
          if(this.maquina === 3) this.bobst106Anno()
          if(this.maquina === 4) this.bittroqueladora3Anno()
          if(this.maquina === 5) this.bittroqueladoran1Anno()
          if(this.maquina === 6) this.bitpegadoraAnno()
          if(this.maquina === 7) this.cierreordenfabricacionAnno()
        }
      },
      cd74Dia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchCD74Dia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      cd74Semana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchCD74Semana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){
                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,
                }

                that.arrData.push(obj)
            })
        })
      },
      cd74Mes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchCD74Mes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){
                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,
                }

                that.arrData.push(obj)
            })
        })
      },
      cd74Anno(){
        let anno = moment(this.anno).year() 
        let payload = {
           
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchCD74Anno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){
                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,
                }

                that.arrData.push(obj)
            })
        })
      },
      guillotinaDia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchGuillotinaDia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      guillotinaSemana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchGuillotinaSemana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      guillotinaMes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchGuillotinaMes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      guillotinaAnno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchGuillotinaAnno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bobst106Dia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchBobst106Dia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bobst106Semana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchBobst106Semana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bobst106Mes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchBobst106Mes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bobst106Anno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchBobst106Anno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladora3Dia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladora3Dia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladora3Semana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladora3Semana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladora3Mes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladora3Mes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladora3Anno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladora3Anno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladoran1Dia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladoraN1Dia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladoran1Semana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladoraN1Semana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladoran1Mes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladoraN1Mes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bittroqueladoran1Anno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchBitTroqueladoraN1Anno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bitpegadoraDia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchBitPegadoraDia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bitpegadoraSemana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchBitPegadoraSemana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bitpegadoraMes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchBitPegadoraMes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      bitpegadoraAnno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchBitPegadoraAnno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      cierreordenfabricacionDia(){
        let payload = {
            'dia' : this.dia
        }
        this.arrData = []//se limpia
        this._fetchCierreOrdenFabricacionDia(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      cierreordenfabricacionSemana(){
        let payload = {
            'semana' : this.semana
        }
        this.arrData = []//se limpia
        this._fetchCierreOrdenFabricacionSemana(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      cierreordenfabricacionMes(){
        let mes = null
        let anno = null
        let partes = this.mes.toString().split(".")
        mes = partes[0]
        anno = partes[1]
        let payload = {
            'mes' : mes,
            'anno' : anno,
        }
        this.arrData = []//se limpia
        this._fetchCierreOrdenFabricacionMes(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
      cierreordenfabricacionAnno(){
        let anno = moment(this.anno).year() 
        let payload = {
            'anno' : anno
        }
        this.arrData = []//se limpia
        this._fetchCierreOrdenFabricacionAnno(payload).then(()=>{
            let that = this
            _.forEach(this.reporte, function(value,key){

                let obj = {
                    'data':value.Contador, 
                    'label':value.Operador,


                }

                that.arrData.push(obj)
            })
        })
      },
    }//methods
  }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
    font-size: 1.5em;
    margin-bottom:0.5em;
}

.panel{
      margin-top:1em;
    }
.generar {
    margin-top:0.5em;
}
.select-maquina{
    margin-top:0.5em;
}
.select-tiempo{
    margin-top:0.5em;
}
.resultado{
  display:flex;
  justify-content: center;
}
.resultado > div {
  width: 50%;
  }
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
    .resultado{
      flex-wrap: wrap;
    }
    .resultado > div{   
    width: 100%;
  }
    
}
</style>